import styled from "@emotion/styled";

export const Wrapper = styled.ul`
  gap: 2px;
  display: flex;
`;

export const Button = styled.button`
  padding: 2px 16px;
`;

export const Box = styled.div`
  background-color: grey;
  display: flex;
  justify-content: space-between;
  padding-right: 24px;
  padding-left: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
  align-items: center;
`;
